import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { adminApi } from "../apis/adminApi";
import { authApi } from "../apis/authApi";

const initialState = {
    Flag: false,
    Clients: [],
    Moderators: [],
    Admins: [],
    Questions: [],
};

const adminSlice = createSlice({
    name: "admin",
    initialState,
    reducers: {
        resetAdminState: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addMatcher(isAnyOf(authApi.endpoints.logout.matchFulfilled, authApi.endpoints.refreshToken.matchRejected), (state) => {
            state.Flag = false;
            state.Clients = [];
            state.Moderators = [];
            state.Admins = [];
            state.Questions = [];
        })
        .addMatcher(isAnyOf(adminApi.endpoints.fetchData.matchFulfilled, adminApi.endpoints.refreshData.matchFulfilled), (state, action) => {
            const { Clients, Moderators, Admins, Questions } = action.payload;
            
            state.Flag = true;
            state.Clients = Clients || [];
            state.Moderators = Moderators || [];
            state.Admins = Admins || [];
            state.Questions = Questions || [];
        })
        .addMatcher(isAnyOf(adminApi.endpoints.editClient.matchFulfilled, adminApi.endpoints.activateClient.matchFulfilled, adminApi.endpoints.deactivateClient.matchFulfilled, adminApi.endpoints.upgradeClient.matchFulfilled, adminApi.endpoints.downgradeClient.matchFulfilled), (state, action) => {
            const updatedClient = action.payload;
            const index = state.Clients.findIndex(client => client.USR_ID === updatedClient.USR_ID);
            if (index !== -1) {
                state.Clients[index] = updatedClient;
            }
        })
        .addMatcher(adminApi.endpoints.deleteClient.matchFulfilled, (state, action) => {
            state.Clients = state.Clients.filter(client => client.USR_ID !== action.payload);
        })
        .addMatcher(adminApi.endpoints.createModerator.matchFulfilled, (state, action) => {
            state.Moderators.push(action.payload);
        })
        .addMatcher(adminApi.endpoints.editModerator.matchFulfilled, (state, action) => {
            const updatedModerator = action.payload;
            const index = state.Moderators.findIndex(client => client.USR_ID === updatedModerator.USR_ID);
            if (index !== -1) {
                state.Moderators[index] = updatedModerator;
            }
        })
        .addMatcher(adminApi.endpoints.deleteModerator.matchFulfilled, (state, action) => {
            state.Moderators = state.Moderators.filter(moderator => moderator.USR_ID !== action.payload);
        })
        .addMatcher(adminApi.endpoints.createAdmin.matchFulfilled, (state, action) => {
            state.Admins.push(action.payload);
        })
        .addMatcher(adminApi.endpoints.editAdmin.matchFulfilled, (state, action) => {
            const updatedAdmin = action.payload;
            const index = state.Admins.findIndex(admin => admin.USR_ID === updatedAdmin.USR_ID);
            if (index !== -1) {
                state.Admins[index] = updatedAdmin;
            }
        })
        .addMatcher(adminApi.endpoints.deleteAdmin.matchFulfilled, (state, action) => {
            state.Admins = state.Admins.filter(admin => admin.USR_ID !== action.payload);
        })
    },
});

export const { resetAdminState } = adminSlice.actions;
export default adminSlice.reducer;